import store from '.././vuex'

export default {
  buildErrorMessages (response) {
    // for (var index in error) {
    //   var attr = error[index]
    //   console.log(attr)
    //   console.log(index)
    // }
    let errors = []
    let messages = []
    if (response.data.message !== undefined) {
      errors = response.data.message
    }
    if (response.data.message_complete !== undefined) {
      errors = response.data.message_complete
    }
    if (response.data.error !== undefined) {
      errors = response.data.error
    }
    if (response.data.error.message !== undefined) {
      errors = response.data.error.message
    }
    if (typeof errors === 'string') {
      messages.push(errors)
    } else {
      for (let key in errors) {
        if (!errors.hasOwnProperty(key)) continue
        if (key === 'errors') {
          messages = messages.concat(this.validationMessages(errors.errors))
        }
      }
    }
    return messages
  },
  validationMessages (errors) {
    let messages = []
    for (var index in errors) {
      let message = store._vm.$t('application.attributes.' + index) + ' ' + errors[index]
      messages.push(message)
    }

    return messages
  }
}



// WEBPACK FOOTER //
// ./src/utils/error-message.js